module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm3_en.d681d0013160ee691958cb116499e13a.png";